export default function TypingIndicator() {
  return (
    <div className="flex gap-3" data-testid="typing-indicator">
      <img 
        src="https://customer-assets.emergentagent.com/job_maquito-helper/artifacts/woi3y581_Recurso%201.svg" 
        alt="Maquito" 
        className="h-8 w-8 rounded-full flex-shrink-0"
      />
      <div className="bg-green-100 rounded-2xl px-4 py-3">
        <div className="flex gap-1">
          <div className="w-2 h-2 bg-green-600 rounded-full typing-dot"></div>
          <div className="w-2 h-2 bg-green-600 rounded-full typing-dot"></div>
          <div className="w-2 h-2 bg-green-600 rounded-full typing-dot"></div>
        </div>
      </div>
    </div>
  );
}